var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C7.125 15.75 5.53125 15.0938 4.21875 13.7812C2.90625 12.4688 2.25 10.875 2.25 9C2.25 7.125 2.90625 5.53125 4.21875 4.21875C5.53125 2.90625 7.125 2.25 9 2.25C9.175 2.25 9.34688 2.25625 9.51563 2.26875C9.68438 2.28125 9.85 2.3 10.0125 2.325C9.5 2.6875 9.09063 3.15938 8.78438 3.74063C8.47813 4.32188 8.325 4.95 8.325 5.625C8.325 6.75 8.71875 7.70625 9.50625 8.49375C10.2938 9.28125 11.25 9.675 12.375 9.675C13.0625 9.675 13.6938 9.52188 14.2688 9.21563C14.8438 8.90938 15.3125 8.5 15.675 7.9875C15.7 8.15 15.7188 8.31563 15.7313 8.48438C15.7438 8.65313 15.75 8.825 15.75 9C15.75 10.875 15.0938 12.4688 13.7812 13.7812C12.4688 15.0938 10.875 15.75 9 15.75ZM9 14.25C10.1 14.25 11.0875 13.9469 11.9625 13.3406C12.8375 12.7344 13.475 11.9438 13.875 10.9688C13.625 11.0312 13.375 11.0813 13.125 11.1188C12.875 11.1562 12.625 11.175 12.375 11.175C10.8375 11.175 9.52813 10.6344 8.44688 9.55313C7.36563 8.47188 6.825 7.1625 6.825 5.625C6.825 5.375 6.84375 5.125 6.88125 4.875C6.91875 4.625 6.96875 4.375 7.03125 4.125C6.05625 4.525 5.26562 5.1625 4.65938 6.0375C4.05313 6.9125 3.75 7.9 3.75 9C3.75 10.45 4.2625 11.6875 5.2875 12.7125C6.3125 13.7375 7.55 14.25 9 14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDark);
export default __webpack_public_path__ + "static/media/icon-dark.f683b5fbf4cc82d8fb4470356d504bb8.svg";
export { ForwardRef as ReactComponent };